// Attach a listener to the messagebus channel and reload the page when
// a message is received.
// This behaviour expects the following data attributes:
// - messagebusChannelName: the name of the messagebus channel to listen to
onDomLoad(function ($dom) {
  function reloadMe() {
    window.location.reload()
  }

  $dom.find("[data-behaviour='wait-for-mum']").each(function () {
    // We are passing a hardcoded 0 instead of the usual MessageBus.last_id
    // because we don't want to miss a message while the MLU reloads the page
    window.Silverfin.Polling.subscribe(
      this.dataset.messagebusChannelName,
      reloadMe,
      0
    )

    // unsubscribe when leaving the page
    document.addEventListener('turbolinks:before-cache', () => {
      window.Silverfin.Polling.unsubscribe(
        this.dataset.messagebusChannelName,
        reloadMe
      )
    })
  })
})
